export default "__VITE_ASSET__deSXnYr3__"